<template>
  <div class="battery-mgmt">
    <div class="sub-body">
      <div class="list">
        <span>优惠券模板编号：</span>
        <el-input class="list-input" size="mini" v-model="number" placeholder="请输入优惠券模板编号" readonly></el-input>
        <span class="ml10">用户编号：</span>
        <el-input class="list-input" size="mini" v-model="userAccountNo" placeholder="请输入优惠券模板编号"></el-input>
        <span class="ml10">用户手机号：</span>
        <el-input class="list-input" size="mini" v-model="phone" placeholder="请输入优惠券模板编号"></el-input>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th width="170px">用户编号</th>
          <th>用户姓名手机号</th>
          <th>适用商品</th>
          <th>领取时间</th>
          <th width="170px">优惠券模板编号</th>
          <th>领取来源</th>
          <th>使用时间</th>
          <th>订单编号</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.commodityTitle }}</td>
          <td>{{ types[item.type] }}</td>
          <td>{{ item.validBeginTime ? item.validBeginTime + '~' + item.validEndTime : '--' }}</td>
          <td>{{ item.status }}</td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="8">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  name: 'discountRecordView',
  data() {
    return {
      number: '',
      userAccountNo: '',
      phone: '',
      pageSize: 10,
      beginIndex: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dataList: [],
    }
  },
  watch: {
    editData: {
      handler() {
        // this.number = this.editData.number;
        this.queryCouponsRecordList();
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    queryCouponsRecordList: function () {
      let self = this;
      let params = {
        userAccountNo: this.userAccountNo,
        phone: this.phone,
        couponsNo: this.number,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      this.$http.post('/managementPlatform/admin/queryUserCouponsRecord', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryCouponsRecordList();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryCouponsRecordList();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryCouponsRecordList();
    },
  },
}
</script>

<style lang="scss" scoped>
.sub-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/marketingMgmt/discountRecordView.vue